import { getMemberQualityStats } from '@kudos/http-client'
import { useQuery } from '@tanstack/react-query'

export const MEMBER_QUALITY_STATS_QK = 'memberQualityStats'

/**
 * All-time counts of the qualities a member has been recognized for, grouped by
 * the value each quality belongs to, across both recognition and awards
 * received. Shared by the About tab's recognition profile and the Recognition
 * tab's summary tiles so the two read from one cache entry.
 */
export const useMemberQualityStats = (memberId: string, enabled = true) =>
  useQuery({
    queryKey: [MEMBER_QUALITY_STATS_QK, memberId],
    queryFn: () => getMemberQualityStats(memberId),
    staleTime: 60 * 1000,
    enabled: enabled && !!memberId,
  })
